export default {
  FlightConfirmationCard__CONFIRMATION_NUMBER_ARIA_LABEL: "Confirmation number",
  FlightConfirmationCard__CONFIRMATION_NUMBER_LABEL: "Confirmation #",
  FlightConfirmationCard__DESTINATIONS_HEADER: (cities) => cities.join(" to "),
};
